import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-center-page',
  templateUrl: './data-center-page.component.html',
  styleUrls: ['./data-center-page.component.css']
})
export class DataCenterPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
